import { getColor } from 'common/constants/_colors';

const scrollbar = ({
  color = 'black',
  alpha = 0.3,
  alphaOnHover = 0.5,
  stroke = 0.8,
  radius = 0.8
} = {}) => `
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: ${stroke}rem;

    }

    &::-webkit-scrollbar {
        width: ${stroke}rem;
        background-color: transparent;

        &:horizontal {
            height: ${stroke}rem;
        }
    }

    &::-webkit-scrollbar-thumb {
        opacity: ${alpha};
        background-color: ${getColor(color, alpha)};
        border-radius: ${radius}rem;

        &:hover {
          background-color: ${getColor(color, alphaOnHover)};
        }
    }
`;

export const verticalScroller = props => `
    overflow-y: auto;
    overflow-x: hidden;
    ${scrollbar(props)}
`;

export const horizontalScroller = props => `
    overflow-y: hidden;
    overflow-x: auto;
    ${scrollbar(props)}
`;
